export default "__VITE_ASSET__DZOIZMNw__"